export { default } from './RequiredMark';
